import { render } from "./Budgets.vue?vue&type=template&id=696a623c&scoped=true"
import script from "./Budgets.vue?vue&type=script&lang=js"
export * from "./Budgets.vue?vue&type=script&lang=js"

import "./Budgets.vue?vue&type=style&index=0&id=696a623c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696a623c"]])

export default __exports__